var styleDataHash = "c182372b";
const injectCss = () => {
  var css = `.glob_fontElementMap,.hkj68{font-family:var(--ricos-font-family,unset)}[dir] .HIzV-{margin:15px 18px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .HIzV-{margin:var(--ricos-custom-code-block-margin,15px calc(18px + 5%))}}}@container (width < 640px){[dir] .HIzV-{margin:var(--ricos-custom-code-block-margin,15px calc(18px + 5%))}}._7nSF1,.wCIfS{font-family:Inconsolata,Menlo,Consolas,monospace;font-size:var(--ricos-custom-code-block-font-size,16px);line-height:var(--ricos-custom-code-block-line-height,26px);white-space:pre-wrap}[dir] ._7nSF1,[dir] .wCIfS{background-color:rgba(var(--ricos-fallback-color-tuple,0,0,0),.06);margin:var(--ricos-custom-code-block-margin,15px 18px);padding:var(--ricos-custom-code-block-padding,2px 25px)}._7nSF1 code,.wCIfS code{font-family:Inconsolata,Menlo,Consolas,monospace;font-size:var(--ricos-custom-code-block-font-size,16px)}[dir] .utIlC ._7nSF1,[dir] .utIlC .wCIfS{margin:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var code_block_default = {
  "fontElementMap": "hkj68",
  "blockStyleSpacing": "HIzV-",
  "codeBlock": "_7nSF1 HIzV-",
  "code": "wCIfS HIzV-",
  "renderedInTable": "utIlC"
};
export {
  code_block_default as default,
  injectCss
};
//# sourceMappingURL=code-block-scss.js.map
